import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import UpdateUserError from '../../../components/organisms/updateUserError';
import { SessionContext } from '../../StoreProvider';

const UpdateUserErrorContainer = ({ userCpf }) => {
  const [isSigningOut, setIsSigningOut] = useState(false);
  const signOut = () => {
    setIsSigningOut(true);
    window.nossaContainer.logOut(true);
  };
  return (
    <div
      className={`confirm-cpf-error-container ${
        isSigningOut ? 'fade-out' : ''
      }`}
    >
      <UpdateUserError signOut={signOut} userCpf={userCpf} />
    </div>
  );
};

UpdateUserErrorContainer.defaultProps = {
  user: {},
  userCpf: null
};

UpdateUserErrorContainer.propTypes = {
  user: PropTypes.shape({
    subscriber: PropTypes.bool,
    userData: PropTypes.object
  }),
  userCpf: PropTypes.string
};

export default props => (
  <UpdateUserErrorContainer {...useContext(SessionContext)} {...props} />
);
